export type FunnelStageData = {
  id: string
  name: string
  value: number
  conversionRate: string // Conversion from previous stage
  dropOffRate: string
  color: string
  description: string
}

export type CampaignData = {
  id: string
  name: string
  leads: number
  creditPulls: number
  applications: number
  submissions: number
  fundings: number
  spend: number
  roi: string
}

export const funnelData: FunnelStageData[] = [
  {
    id: 'campaign',
    name: 'Campaign Leads',
    value: 1000,
    conversionRate: '100%',
    dropOffRate: '0%',
    color: '#3b82f6', // blue-500
    description: 'Total leads generated across all active campaigns',
  },
  {
    id: 'credit_pull',
    name: 'Credit Pulls',
    value: 400,
    conversionRate: '40%',
    dropOffRate: '60%',
    color: '#6366f1', // indigo-500
    description: 'Leads with sufficient intent to authorize credit check',
  },
  {
    id: 'application',
    name: 'Applications',
    value: 200,
    conversionRate: '50%',
    dropOffRate: '50%',
    color: '#8b5cf6', // violet-500
    description: 'Full loan applications started capturing parameters',
  },
  {
    id: 'submission',
    name: 'Submissions',
    value: 100,
    conversionRate: '50%',
    dropOffRate: '50%',
    color: '#ec4899', // pink-500
    description: 'Files sent to underwriting for approval',
  },
  {
    id: 'funding',
    name: 'Fundings',
    value: 60,
    conversionRate: '60%',
    dropOffRate: '40%',
    color: '#10b981', // emerald-500
    description: 'Closed loans that have been funded',
  },
]

export const campaignData: CampaignData[] = [
  {
    id: '1',
    name: 'Google Search Ads - Q1',
    leads: 450,
    creditPulls: 200,
    applications: 110,
    submissions: 60,
    fundings: 40,
    spend: 15000,
    roi: '280%',
  },
  {
    id: '2',
    name: 'Referral Program',
    leads: 150,
    creditPulls: 120,
    applications: 80,
    submissions: 50,
    fundings: 45,
    spend: 2000,
    roi: '850%',
  },
  {
    id: '3',
    name: 'Facebook Retargeting',
    leads: 300,
    creditPulls: 60,
    applications: 20,
    submissions: 10,
    fundings: 5,
    spend: 5000,
    roi: '110%',
  },
  {
    id: '4',
    name: 'Email Nurture Drip',
    leads: 100,
    creditPulls: 20,
    applications: 10,
    submissions: 5,
    fundings: 2,
    spend: 500,
    roi: '320%',
  },
]
